import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  ButtonBase,
  TwoColumnSectionBase,
  CenteredGridBase,
} from "@reusejs/react";
import LinkedInSvg from "../../Icons/LinkedIn";
import Link from "next/link";
import { getWatermarkedImgixUrl } from "services";

let sectionHeader = {
  title: "Our Experts",
  description:
    "We are available at any time to assist you in acquiring a property.",
};

let expertsCardsItems = [
  {
    img: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/8eedade6-8d91-40c2-8726-691e8b291853?fill=fit&auto=format`,
    ),
    name: "RAMACHANDRA RAO A",
    designation: "Founder & CEO",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    linkedInProfile: "https://linkedin.com/in/ramchandrarao",
  },
  {
    img: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/d757b114-b0fa-4071-82fc-e787f6a4eace?fill=fit&auto=format`,
    ),
    name: "DEEPTHI KANDIRAJU",
    designation: "Director - Technology",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    linkedInProfile: "https://linkedin.com/in/deepthikandiraju",
  },
  {
    img: getWatermarkedImgixUrl(
      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/b9a17ae0-5c5e-4c68-a633-0aa881f9a8ac?fill=fit&auto=format`,
    ),
    name: "SHIVARAMAKRISHNA B",
    designation: "Director - Operations",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    linkedInProfile: "https://linkedin.com/in/shivaramakrishnabehara",
  },
  // {
  //   img: getWatermarkedImgixUrl(`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/44eabc2a-0d55-4cb3-ae8f-bf017ed59f6c?fill=fit&auto=format`),
  //   name: "MALLESH BOINOLLA",
  //   designation: "Regional Head - Sales and Partnership",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
  //   linkedInProfile:
  //     "https://www.linkedin.com/in/mallesh-mudiraj-boinolla-33681b17",
  // },
];

const Actions = () => {
  return (
    <div className="mt-4 md:mt-8 flex justify-start items-center md:items-[initial] md:justify-center">
      <div className="w-full md:w-[initial] mr-2">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Talk to our Expert"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            padding: "px-0 md:px-4 py-3",
            width: "w-full md:w-[initial]",
          }}
        />
      </div>
      <div className="w-full md:w-[initial]">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Know more"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-black hover:text-blue-700",
            border: "border border-black border hover:border-blue-700",
            width: "w-full md:w-[initial]",
            padding: "py-3 px-4",
          }}
        />
      </div>
    </div>
  );
};

export default function ExpertsComponentWithCards(props: any) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: `py-10 md:py-20 ${
          props.pageWiseBgColor ? props.pageWiseBgColor : ""
        }`,
        innerContainerStyles: "max-w-7xl mx-auto px-4 md:px-6 lg:px-8 xl:px-0",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionHeader.title}
        description={sectionHeader.description}
        actions={props.showActions ? <Actions /> : null}
        itemTitleDescriptionCardBaseClasses={{
          iconWrapper:
            "flex h-12 w-12 items-center justify-center rounded-md text-white",
          titleWrapper: "mt-2 text-start  md:text-center",
          titleStyles: "text-2xl leading-8 md:text-4xl font-extrabold",
          descriptionWrapper:
            "text-start md:text-center mt-3 md:mt-4 max-w-xl mx-auto pr-16 md:pr-[initial]",
          descriptionStyles: "text-sm md:text-lg text-gray-500 font-light",
          actionWrapper: "mt-2 text-left",
        }}
      />

      {props.showExpertCards && (
        <div className="flex justify-center">
          <CenteredGridBase
            itemsRenderer={() => (
              <ExpertsCardComponent
                items={expertsCardsItems}
                pageWiseHeadingColor={props.pageWiseHeadingColor}
                pageWiseDescriptionColor={props.pageWiseDescriptionColor}
                cardBgColor={props.cardBgColor ? props.cardBgColor : ""}
              />
            )}
            centeredGridBaseClasses={{
              // gridWrapper: "mt-10 max-w-6xl",
              gridClasses:
                "space-y-10 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-16 md:gap-y-10",
            }}
          />
        </div>
      )}
    </SectionContainerBase>
  );
}

const ExpertImgComponent = (props: any) => {
  return (
    <div className="w-full h-full">
      <img
        className="mx-auto h-full w-full object-cover"
        src={props.expertImg}
        alt="expert"
      />
    </div>
  );
};

const ExpertDetailComponent = (props: any) => {
  return (
    <div className="flex flex-col gap-y-1.5">
      <div className="text-xl font-semibold">{props.expert.name}</div>

      <div className="text-base text-gray-500 h-12 font-normal">
        {props.expert.designation}
      </div>

      <div>
        <Link href={props.expert.linkedInProfile}>
          <a className="cursor-auto">
            <LinkedInSvg className="flex cursor-pointer items-center text-sm font-medium text-gray-500 hover:text-blue-600" />
          </a>
        </Link>
      </div>
    </div>
  );
};

const ExpertsCardComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <TwoColumnSectionBase
            key={index}
            firstColumnEl={<ExpertImgComponent expertImg={item.img} />}
            secondColumnEl={<ExpertDetailComponent expert={item} />}
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles: "w-full h-72",
              secondElWrapperStyles: "w-full self-stretch pt-5",
              columnsFlexWrapperStyles:
                "flex items-center justify-between flex-col rounded-lg  shadow-xl p-4",
            }}
          />
        );
      })}
    </>
  );
};
